import React, { useState, useEffect } from "react";
import Base from "../../Config/Base";
import { Link } from "react-router-dom";
import { API_BASE_CRM_URL } from "../../Config/Config";
import { Select } from "antd";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import "../../Config/swal.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { useLabelContext } from "../../../Context";

export default function EditInvoice() {
  const [userDetails, SetUserDetails] = useState([]);
  const navigate = useNavigate();
  const { ID } = useLabelContext();
  const InvoiceID = ID;
  const [invoiceData, setInvoiceData] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [formValues, setFormValues] = useState({
    clientid: "",
    cus_name: "",
    status: "",
    proj_name: "",
    project_id: "",
    datecreated: "",
    discount_total: "",
    discount_type: "",
    discount_percent: "",
    duedate: "",
    total_tax: "",
    subtotal: "",
    sale_agent: "",
    paymentmode: "",
  });

  useEffect(() => {
    const userDetailsSession = JSON.parse(
      sessionStorage.getItem("userDetails")
    );
    SetUserDetails(userDetailsSession);
  }, []);

  const [selectedCustomerid, setSelectedCustomerid] = useState("");
  const [selectedprojectid, setSelectedProjectid] = useState("");
  const [selectedStatusid, setSelectedStatusid] = useState("");
  const [selectedStaffid, setSelectedStaffid] = useState("");
  const [selectedPaymentModeid, setSelectedPaymentModeid] = useState("");
  const [totalAmount, setTotalAmount] = useState(0);
  const [totalTaxAmount, setTotalTaxAmount] = useState(0);
  const [customersData, setCustomersData] = useState([]);
  const [projectsData, setProjectsData] = useState([]);
  const [productsData, setProductsData] = useState([]);
  const [staffData, setStaffData] = useState([]);
  const [paymentModesData, setPaymentModesData] = useState([]);
  const [taxesData, setTaxesData] = useState([]);
  const [discountTotal, setDiscountTotal] = useState(0);
  const [discountPercentage, setDiscountPercentage] = useState("");
  const [selecteddiscount, setselecteddiscount] = useState("");
  const [selectedTax, setSelectedTax] = useState("");

  const [description, setDescription] = useState("");
  const [dueDate, setDueDate] = useState("");
  const [invoiceDate, setInvoiceDate] = useState("");
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const userDetailsSession = JSON.parse(
      sessionStorage.getItem("userDetails")
    );
    SetUserDetails(userDetailsSession);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_BASE_CRM_URL}GetCustomers`);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        if (data.Status) {
          setCustomersData(data.ResultData);
        } else {
          console.error("Fetched data is not an array:", data);
          setCustomersData([]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_BASE_CRM_URL}GetStaff`);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        if (data.Status) {
          setStaffData(data.ResultData);
        } else {
          console.error("Fetched data is not an array:", data);
          setStaffData([]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_BASE_CRM_URL}GetPaymentModes`);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        if (data.Status) {
          setPaymentModesData(data.ResultData);
        } else {
          console.error("Fetched data is not an array:", data);
          setPaymentModesData([]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_BASE_CRM_URL}GetTaxes`);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        if (data.Status) {
          setTaxesData(data.ResultData);
        } else {
          console.error("Fetched data is not an array:", data);
          setTaxesData([]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_BASE_CRM_URL}GetProducts`);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        if (data.Status) {
          setProductsData(data.ResultData);
        } else {
          console.error("Fetched data is not an array:", data);
          setProductsData([]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (selectedCustomerid) {
      const fetchData = async () => {
        try {
          const response = await fetch(
            `${API_BASE_CRM_URL}GetProjectsByCusId?CusID=${selectedCustomerid}`
          );
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          const data = await response.json();
          if (data.Status) {
            setProjectsData(data.ResultData);
          } else {
            console.error("Fetched data is not an array:", data);
            setProjectsData([]);
          }
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };
      fetchData();
    }
  }, [selectedCustomerid]);

  useEffect(() => {
    if (InvoiceID) {
      sessionStorage.setItem("purchaseId", JSON.stringify(InvoiceID));
    }

    let storedPurchaseId = sessionStorage.getItem("purchaseId");
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `${API_BASE_CRM_URL}GetInvoicesById?ID=${storedPurchaseId}`
        );
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        console.log(data);
        if (data.Status) {
          setLoading(false);
          setRows(data.ResultData.items);
          console.log(data.ResultData.details);
          setFormValues({
            clientid: data.ResultData.details.clientid,
            cus_name: data.ResultData.details.cus_name,
            status: data.ResultData.details.status,
            project_id: data.ResultData.details.project_id,
            discount_total: data.ResultData.details.discount_total,
            discount_type: data.ResultData.details.discount_type,
            discount_percent: data.ResultData.details.discount_percent,
            total_tax: data.ResultData.details.total_tax,
            subtotal: data.ResultData.details.subtotal,
            proj_name: data.ResultData.details.proj_name,
            datecreated: formatDate(data.ResultData.details.date),
            duedate: formatDate(data.ResultData.details.duedate),
            sale_agent: data.ResultData.details.sale_agent,
            total: data.ResultData.details.total,
            paymentmode: data.ResultData.details.allowed_payment_modes,
          });
          console.log(data.ResultData.details);
          setSelectedCustomerid(data.ResultData.details.customer_code || "");
          setSelectedProjectid(data.ResultData.project || "");
          setselecteddiscount(data.ResultData.details.discount_type)
        } else {
          console.error("Fetched data is not an array:", data);
          setLoading(false);
          setInvoiceData([]);
        }
      } catch (error) {
        setLoading(false);
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [InvoiceID]);

  const formatDate = (isoString) => {
    if (!isoString) return "";
    const date = new Date(isoString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const customerOptions =
    customersData &&
    customersData.map((item) => ({
      value: item.userid,
      label: item.company,
    }));

  const projectOptions =
    projectsData &&
    projectsData.map((item) => ({
      value: item.id,
      label: item.name,
    }));

  const paymentModeOptions =
    paymentModesData &&
    paymentModesData.map((item) => ({
      value: item.id,
      label: item.name,
    }));

  const productOptions =
    productsData &&
    productsData.map((item) => ({
      value: item.long_description,
      label: item.description,
      rate: parseFloat(item.rate),
    }));

  const staffOptions =
    staffData &&
    staffData.map((item) => ({
      value: item.staffid,
      label: item.firstname + " " + item.lastname,
    }));

  const taxOptions =
    taxesData &&
    taxesData.map((item) => ({
      key: item.id,
      value: item.taxrate,
      label: item.name + " " + item.taxrate,
    }));

  const statusOptions = [
    { value: 1, label: "Draft" },
    { value: 2, label: "Sent" },
    { value: 5, label: "Expired" },
    { value: 3, label: "Declined" },
    { value: 4, label: "Accepted" },
  ];
  const discountoptions = [
    { "value": "No discount", "label": "No discount" },
    { "value": "Before tax", "label": "Before tax" },
    { "value": "After tax", "label": "After tax" },
  ]

  const handleCustomerChange = (selectedOption) => {
    setSelectedCustomerid(selectedOption);
    const label = customersData.filter(
      (item) => item.userid === selectedOption
    );
    // console.log(label[0].company);
    setFormValues((prevData) => ({
      ...prevData,
      clientid: selectedOption,
      cus_name: label[0].company,
    }));
  };

  const handleProjectChange = (selectedone) => {
    setSelectedProjectid(selectedone);
    const label = projectsData.filter((item) => item.id === selectedone);
    console.log(label);
    setFormValues((prevData) => ({
      ...prevData,
      project_id: selectedone,
      proj_name: label[0].name,
    }));
  };

  const handleStatusChange = (selectedone) => {
    setSelectedStatusid(selectedone);
    setFormValues((prevData) => ({
      ...prevData,
      status: selectedone,
    }));
  };

  const handleStaffChange = (selectedone) => {
    setSelectedStaffid(selectedone);
    setFormValues((prevData) => ({
      ...prevData,
      sale_agent: selectedone,
    }));
  };

  const handlediscountChange = (selectedone) => {
    console.log(selectedone);
    setselecteddiscount(selectedone);
  };

  const handlePaymentModeChange = (selectedone) => {
    setSelectedPaymentModeid(selectedone);
    const label = paymentModesData.filter((item) => item.id === selectedone);
    console.log(label[0].name);
    setFormValues((prevData) => ({
      ...prevData,
      paymentmode: label[0].name,
    }));
  };

  const handleInvoiceDateChange = (event) => {
    setInvoiceDate(event.target.value);
    setFormValues((prevData) => ({
      ...prevData,
      datecreated: event.target.value,
    }));
  };

  const handledueDateChange = (event) => {
    setDueDate(event.target.value);
    setFormValues((prevData) => ({
      ...prevData,
      duedate: event.target.value,
    }));
  };

  const addRow = (product) => {
    if (rows.some((row) => row.description === product.label)) {
      Swal.fire({
        title: "Product already added",
        text: "This product is already in the list.",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return;
    }

    const newRow = {
      description: product.label,
      long_description: product.value || "",
      qty: "",
      rate: product.rate,
      tax: "",
      amount: 0,
      item_order: rows.length + 1,
    };

    setRows([...rows, newRow]);
    // setSelectedProducts(null);
  };
  const handleProductChange = (value, option) => {
    setSelectedProduct(option);
    addRow(option);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const filteredOptions = selectedProduct ? [selectedProduct] : productOptions;


  const handleInputChange = (index, key, value) => {
    setRows(prevRows => {
      const updatedRows = [...prevRows];

      const parsedValue = isNaN(parseFloat(value)) || value === "" ? 0 : parseFloat(value);
      updatedRows[index][key] = parsedValue;

      const rate = parseFloat(updatedRows[index].rate) || 0;
      const qty = parseFloat(updatedRows[index].qty) || 0;
      let rowSubtotal = rate * qty;

      const selectedTax = taxOptions.find(option => option.value === updatedRows[index].taxrate);
      const taxPercentage = selectedTax ? parseFloat(selectedTax.percentage) || 0 : 0;

      let taxAmount = rowSubtotal * (taxPercentage / 100);
      let rowAmount = rowSubtotal + taxAmount;

      const discountPercentage = parseFloat(formValues?.discount_percent) || 0;
      let discountAmount = 0;

      if (selecteddiscount === "Before tax") {
        discountAmount = (rowSubtotal * discountPercentage) / 100;
        rowSubtotal -= discountAmount;
        taxAmount = rowSubtotal * (taxPercentage / 100);
        rowAmount = rowSubtotal + taxAmount;
      } else if (selecteddiscount === "After tax") {
        discountAmount = (rowAmount * discountPercentage) / 100;
        rowAmount -= discountAmount;
      }

      updatedRows[index].discountAmount = discountAmount.toFixed(2);
      updatedRows[index].amount = isNaN(rowAmount) ? "0.00" : rowAmount.toFixed(2);

      return updatedRows;
    });

    setTimeout(() => recalculateTotals(), 0);
  };

  const handleDiscountChange = (e) => {
    const discountPercent = parseFloat(e.target.value) || 0;

    setFormValues(prev => ({
      ...prev,
      discount_percent: discountPercent
    }));

    setTimeout(() => recalculateTotals(), 0);
  };

  const recalculateTotals = () => {
    setRows(prevRows => {
      let totalAmount = 0;

      prevRows.forEach(row => {
        const rowAmount = parseFloat(row.amount) || 0;
        totalAmount += rowAmount;
      });

      const discountPercentage = parseFloat(formValues?.discount_percent) || 0;
      const discountTotal = (totalAmount * discountPercentage) / 100;
      const finalAmount = totalAmount - discountTotal;

      setFormValues(prev => ({
        ...prev,
        discount_total: isNaN(discountTotal) ? "0.00" : discountTotal.toFixed(2),
        total: isNaN(finalAmount) ? "0.00" : finalAmount.toFixed(2),
      }));

      return prevRows;
    });
  };

  const handleTaxChange = (index, taxOption) => {
    setSelectedTax(taxOption);
    setRows(prevRows => {
      const updatedRows = [...prevRows];
      const updatedRow = { ...updatedRows[index], taxrate: taxOption };

      const rate = parseFloat(updatedRow.rate) || 0;
      const qty = parseFloat(updatedRow.qty) || 0;
      const taxPercentage = parseFloat(taxOption) || 0;

      const subtotal = rate * qty;
      const totalTaxAmount = subtotal * (taxPercentage / 100);
      const totalAmount = subtotal + totalTaxAmount;

      updatedRow.amount = totalAmount.toFixed(2);
      console.log(totalAmount)

      updatedRows[index] = updatedRow;
      return updatedRows;

    });
    setFormValues({
      ...formValues,
      total: totalAmount,
      total_tax: totalTaxAmount
    });

  };

  const calculateAmount = ({ qty, rate, tax }) => {
    const quantity = parseFloat(qty) || 0;
    const rateValue = parseFloat(rate) || 0;
    const taxRate = parseFloat(tax) || 0;
    return (quantity * rateValue * (1 + taxRate / 100)).toFixed(2);
  };

  const calculateTotal = () => {
    return rows
      .reduce((total, row) => total + parseFloat(row.qty * row.rate), 0)
      .toFixed(2);
  };


  const handleDelete = async (index, id) => {
    if (!id) {
      console.warn("ID not found, deleting manually from UI.");
      setRows((prevRows) => prevRows.filter((_, rowIndex) => rowIndex !== index));
      return;
    }

    const requestData = {
      id: id,
      rel_type: "Invoice",
      rel_id: InvoiceID,
    };

    console.log("Deleting item:", requestData);

    try {
      const response = await fetch(`${API_BASE_CRM_URL}DeleteItem`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      if (!response.ok) {
        throw new Error("Failed to delete item from backend");
      }

      setRows((prevRows) => prevRows.filter((_, rowIndex) => rowIndex !== index));

      console.log(`Item with ID ${id} deleted successfully.`);
    } catch (error) {
      console.error("Error deleting item:", error);
      alert("Failed to delete the item. Please try again.");
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const totalAmount = calculateTotal();

    const InvoiceData = {
      id: InvoiceID,
      clientid: formValues.clientid,
      discount_percent: formValues.discount_percent,
      discount_total: formValues.discount_total,
      subtotal: formValues.subtotal,
      total_tax: formValues.total_tax,
      status: formValues.status,
      proj_name: formValues.proj_name,
      project_id: formValues.project_id,
      datecreated: formValues.datecreated,
      date: formValues.datecreated,
      duedate: formValues.duedate,
      sale_agent: formValues.sale_agent,
      paymentmode: formValues.paymentmode,

      total: calculateTotal(),
      products: rows,
    };

    console.log(InvoiceData, "data sending to api");

    try {
      const response = await fetch(`${API_BASE_CRM_URL}UpdateInvoice`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(InvoiceData),
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const result = await response.json();
      console.log(result, "rrrrrrrrrrrrrrrrrrr");
      if (result.Status) {
        setLoading(false);
        Swal.fire({
          title: `Invoice updated Successfully.`,
          icon: "success",
          customClass: {
            title: "swal-title",
            content: "swal-text",
          },
        }).then((result) => {
          if (result.isConfirmed || result.isDismissed) {
            // window.location.reload();
            navigate("/invoice");
          }
        });
      } else {
        setLoading(false);
        Swal.fire({
          title: "Error",
          text: "Failed to submit request.",
          icon: "error",
          customClass: {
            title: "swal-title",
            content: "swal-text",
          },
        });
      }
    } catch (error) {
      setLoading(false);
      console.error("Error:", error);
    }
  };

  return (
    <Base>
      <div className="page-header">
        <div className="add-item d-flex">
          <div className="page-title">
            <h4>Edit Invoice</h4>
            <h6>Modify fields for invocie</h6>
          </div>
        </div>
        <ul className="table-top-head">
          <li>
            <Link to="/invoice" className="btn btn-added">
              <i className="fa-solid fa-arrow-left me-1"></i>Go to List
            </Link>
          </li>
        </ul>
      </div>

      <div className="card table-list-card">
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="row m-2">
              <div className="d-flex flex-column col-lg-4 col-md-4 mb-2">
                <label className="form-label">Customer</label>
                <Select
                  showSearch
                  placeholder="Choose Customer"
                  value={formValues.clientid || null}
                  onChange={handleCustomerChange}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={customerOptions}
                  style={{ height: "2.4rem" }}
                />
              </div>
              <div className="d-flex flex-column col-lg-4 col-md-4 mb-2">
                <label className="form-label">Project</label>
                <Select
                  showSearch
                  placeholder="Choose project"
                  value={formValues.proj_name || null}
                  onChange={handleProjectChange}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={projectOptions}
                  style={{ height: "2.4rem" }}
                />
              </div>
              <div className="d-flex flex-column col-lg-4 col-md-4 mb-2">
                <label className="form-label">Status</label>
                <Select
                  showSearch
                  placeholder="Choose status"
                  value={formValues.status || null}
                  onChange={handleStatusChange}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={statusOptions}
                  style={{ height: "2.4rem" }}
                />
              </div>
              <div className="d-flex flex-column col-lg-4 col-md-4 mb-2">
                <label className="form-label">Discount Type</label>
                <Select
                  showSearch
                  placeholder="Choose status"
                  value={selecteddiscount || null}
                  onChange={handlediscountChange}
                  filterOption={(input, option) =>
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                  }
                  options={discountoptions}
                  style={{ height: '2.4rem' }}
                />
              </div>
              <div className="d-flex flex-column col-lg-4 col-md-4 mb-2">
                <label className="form-label">Invoice Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={formValues.datecreated}
                  onChange={handleInvoiceDateChange}
                />
              </div>
              <div className="d-flex flex-column col-lg-4 col-md-4 mb-2">
                <label className="form-label">Due Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={formValues.duedate}
                  onChange={handledueDateChange}
                />
              </div>
              <div className="d-flex flex-column col-lg-4 col-md-4 mb-2">
                <label className="form-label">Sale Agent</label>
                <Select
                  showSearch
                  placeholder="Choose agent"
                  value={formValues.sale_agent || null}
                  onChange={handleStaffChange}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={staffOptions}
                  style={{ height: "2.4rem" }}
                />
              </div>
              <div className="d-flex flex-column col-lg-4 col-md-4 mb-2">
                <label className="form-label">Payment Mode</label>
                <Select
                  showSearch
                  placeholder="Choose payment mode"
                  value={formValues.paymentmode || null}
                  onChange={handlePaymentModeChange}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={paymentModeOptions}
                  style={{ height: "2.4rem" }}
                />
              </div>
              <div className="d-flex flex-column col-lg-4 col-md-4 mb-2">
                <label className="form-label">Product</label>
                <Select
                  showSearch
                  placeholder="Choose product"
                  value={selectedProduct}
                  onChange={handleProductChange}
                  filterOption={(input, option) =>
                    (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                  }
                  options={filteredOptions}
                  style={{ height: "2.4rem" }}
                />
              </div>
              <div className="col-12 my-3 table-responsive">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Product</th>
                      <th>Quantity</th>
                      <th>Rate</th>
                      <th>Tax</th>
                      <th>Amount</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.map((row, index) => (
                      <tr key={row.id}>
                        <td>{index + 1}</td>
                        <td>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Product name"
                            value={row.description}
                            onChange={(e) =>
                              handleInputChange(
                                index,
                                "description",
                                e.target.value
                              )
                            }
                            readOnly
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            className="form-control"
                            placeholder="Quantity"
                            style={{ width: "5rem" }}
                            value={row.qty}
                            onChange={(e) =>
                              handleInputChange(index, "qty", e.target.value)
                            }
                            onWheel={(e) => e.target.blur()}
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            className="form-control"
                            placeholder="Rate"
                            style={{ width: "7rem" }}
                            value={row.rate}
                            onChange={(e) =>
                              handleInputChange(index, "rate", e.target.value)
                            }
                            onWheel={(e) => e.target.blur()}
                          />
                        </td>
                        <td>
                          <Select
                            showSearch
                            placeholder="Choose tax"
                            value={row.taxrate}
                            onChange={(value) => handleTaxChange(index, value)}
                            options={taxOptions.map(option => ({ ...option, key: option.key }))}
                            style={{ height: '2.4rem', width: '7rem' }}
                          />
                        </td>
                        <td>{row.qty * row.rate}</td>
                        <td>
                          <button
                            className="btn"
                            type="button"
                            onClick={() => handleDelete(index, row.id)}
                          >
                            <FontAwesomeIcon
                              icon={faTrashCan}
                              className="text-danger fs-6"
                            />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="col-12 my-3 text-end">
                <label className="form-label">Discount percentage</label>
                <input
                  type="number"
                  className="form-control"
                  name="discount_percent"
                  value={formValues?.discount_percent}
                  onChange={handleDiscountChange}>
                </input>
              </div>
              <div className="col-12 my-3 text-end">
                <h5>Discount Amount: {formValues?.discount_total}</h5>
              </div>
              <div className="col-12 my-3 text-end">
                <h5>Total Amount: {formValues?.total}</h5>
              </div>
              <div className="d-flex flex-column col-lg-12 col-md-12">
                <label className="form-label">Description</label>
                <textarea
                  type="text"
                  className="form-control"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  placeholder="Enter notes..."
                />
              </div>
              <div className="d-flex flex-column col-2 m-auto mt-2">
                <button className="btn btn-primary" type="submit">
                  {loading ? "Submitting..." : "Submit"}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </Base>
  );
}
